import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import StorageService from "services/StorageService";

function Auth(props) {
  const navigate = useNavigate();

  const token = StorageService.getToken();
  const accessLevel = StorageService.getAccessLevel();

  const isUserAccessLevelValid = () => {
    if (!props || !props.accessLevel) return true;
    if (!token || !accessLevel) return false;
    return accessLevel >= props.accessLevel;
  };

  useEffect(() => {
    if (!isUserAccessLevelValid()) navigate("/login");
  });

  return <></>;
}

export default Auth;
